import axios from '@/utils/axios';
/*

    고객관련 API set 입니다.

*/

export function useClient() {
  /*
    고객 본인 정보 조회
  */
  const getClientInfo = async () => {
    try {
      const { data } = await axios.get<api.client.getInfo.response>('/clients');

      if (!data.success) throw data;

      return data;
    } catch (e) {
      throw e;
    }
  };
  /**
   * 고객 역할(유닛/그룹/None) 조회
   */
  const getClientUnitInfo = async () => {
    try {
      const { data } = await axios.get<api.client.getInfo.clientUnitInfo>('/units/me');
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };
  /*
    고객 본인 비밀번호 변경
  */
  const updateClientPassword = async (payload: api.clientPassword.payload) => {
    try {
      const { data } = await axios.patch<api.clientPassword.response>('/clients/password', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
    이메일찾기
  */
  const findClientEmail = async (payload: api.clientEmail.payload) => {
    try {
      const { data } = await axios.post<api.clientEmail.response>('/clients/email/find', payload, {
        headers: { 'X-bypass': true },
      });

      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };
  /*
    새 비밀번호로 변경
  */
  const findClientPassword = async (payload: api.clientFindPassword.payload) => {
    try {
      const { data } = await axios.patch<api.clientFindPassword.response>('/clients/password/change/outside', payload, {
        headers: { 'X-bypass': true },
      });

      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
   마케팅 수신 여부 동의 변경
  */
  const updateMarketingAgreement = async (payload: { agreement: boolean }) => {
    try {
      const { data } = await axios.patch<api.commonResponse>('/tos/marketing', payload);

      if (!data.success) throw data;
      return data;
    } catch (error) {
      throw error;
    }
  };

  /**
   * 외부연동 사용자 활성화 API ( + 마켓팅동의여부 업데이트)
   * @param token : 외부연동 사용자 정보가 들어있는 토큰
   * @param marketingAgreement : 마켓팅동의 여부
   */
  const activateExternalClient = async (payload: { token: string; marketingAgreement: boolean }) => {
    try {
      const { data } = await axios.post('/auth/external-integartion/activate-client', payload);
      if (!data.success) throw data;
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    getClientInfo,
    getClientUnitInfo,
    updateClientPassword,
    findClientEmail,
    findClientPassword,
    updateMarketingAgreement,
    activateExternalClient,
  };
}
